import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputLabel, Checkbox, TextField, Button, CircularProgress } from "@mui/material";
import { useForm } from "react-hook-form";
import { finalDeliveryModalValidationSchema } from "src/helpers/yup_schema";
import { commonFileUpload } from "src/thunks/dashboard";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { toast } from "react-toastify";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { GetError, AddingZeroOnTime } from "src/constant";


const FinalDeliveryForm = ({ handleFinalDeliveredModalClose, activeData, getAllDetails, OnchangeDetailHandler }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { getIndividualDispatchOrderData, addNewVehicleLoadingState } = useSelector((state) => state.dispatch);
  const lookupValues = useSelector((state) => state.lookup.data);

  /** hooks useState ----------------------------------------------------- **/
  const [document, _document] = useState([]);
  const [returnWithGoods, _returnWithGoods] = useState(false);
  const [documentLoader, setDocumentLoader] = useState(false);
  const [finalDeliveryStateData, _finalDeliveryStateData] = useState({
    date: new Date(),
    deliveryTime1: moment().hour(),
    deliveryTime2: moment().minute(),
    onsiteTime1: "00",
    onsiteTime2: "00",
  });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(finalDeliveryModalValidationSchema),
  });

  /** handler functions--------------------------------------------------- **/
  const OnFinalDeliverySubmitHandler = async (data) => {
    if (finalDeliveryStateData.onsiteTime1 == "00" && finalDeliveryStateData.onsiteTime2 == "00") {
      toast.error("Please add onsite time here")
    } else {

      let time = moment.utc(new Date(moment(finalDeliveryStateData.date).format("YYYY-MM-DD") + ' ' + `${AddingZeroOnTime(finalDeliveryStateData.deliveryTime1)}:${AddingZeroOnTime(finalDeliveryStateData.deliveryTime2)}:00`))
      let newData = {
        deliveredDate: `${moment(time).format("YYYY-MM-DD")}T${moment(time).format("HH:mm:ss")}`,
        transitTime: null,
        onSiteTime: `${AddingZeroOnTime(finalDeliveryStateData.onsiteTime1)}:${AddingZeroOnTime(finalDeliveryStateData.onsiteTime2)}:00`,
        receiverName: data.receiverName,
        receiverPosition: data.receiverPosition,
        receiverPhone: (data.receiverPhone).toString(),
        deliveryEvidences: document,
        dispatchStatus: "Delivered",
        statusId: lookupValues?.find(
          (lv) => lv.name === "Delivered" && lv.typeName === "DispatchStatus"
        ).id,
      };
      OnchangeDetailHandler(newData);
    }
  };

  const documentUpload = async (e) => {
    setDocumentLoader(true)
    const files = e.target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      let res = await dispatch(commonFileUpload(formData)).unwrap();
      setDocumentLoader(false);
      let DocumentType = lookupValues?.find((v) => v.name === "Documents").id;
      const processedData = res.map((result) => ({
        ...result,
        type: DocumentType,
        isDamaged: false,
        dispatchId: activeData.id,
      }));
      processedData &&
        processedData[0] &&
        processedData.forEach((item) => {
          _document((prevState) => {
            return [
              ...prevState,
              {
                typeId: item.type,
                url: item.url,
                isDamaged: item.isDamaged,
                fileName: item.fileName,
                uniqueFileId: item.uniqueFileId,
                dispatchId: item.dispatchId,
              },
            ];
          });
        });

    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
      setDocumentLoader(false)
    }

  };

  const allOnChangeHandler = (title, value) => {
    _finalDeliveryStateData({ ...finalDeliveryStateData, [title]: value });
  };

  return (
    <>
      <div>
        <div className="depot-form-header-style">
          <span className="allocate-mgnr-header-color me-2">
            COMPLETE DELIVERY{" "}
          </span>
          <span className="allocate-mgnr-subheader-color">
            {getIndividualDispatchOrderData?.orderNo || ""}
          </span>
          <span className="allocate-mgnr-subheader-color ms-2">
            {activeData?.vehicleRegistration}
          </span>
        </div>

        <div className="mt-5" style={{ paddingLeft: 100, paddingRight: 100 }}>
          <form onSubmit={handleSubmit(OnFinalDeliverySubmitHandler)}>
            <div className="row">
              <div className="col-md-3">
                <div className="d-flex flex-column">
                  <span className="section-name-form-style">DELIVERY DATE</span>
                  <div className="add-mr-top-for-final-delivery">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        value={finalDeliveryStateData.date}
                        label="Date"
                        onChange={(newValue) =>
                          allOnChangeHandler("date", newValue)
                        }
                        className="DatePickerOutline"
                        variant="standard"
                        id="standard-basic"
                        format="dd.MM.yyyy"
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="d-flex flex-column">
                  <span className="section-name-form-style">TIME</span>
                  <div className=" add-mr-top-for-final-delivery">
                    <select
                      value={finalDeliveryStateData.deliveryTime1}
                      onChange={({ target }) =>
                        allOnChangeHandler("deliveryTime1", target.value)
                      }
                      style={{
                        textAlign: "center",
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        borderBottom: "1px solid #5e89e7",
                        height: 42,
                      }}
                    >
                      {[...Array(24)].map((d, index) => {
                        const formattedValue = index.toString().padStart(2, '0');
                        return (
                          <option key={index} value={index}>
                            {/* {index} */}
                            {formattedValue}
                          </option>
                        );
                      })}
                    </select>
                    :
                    <select
                      value={finalDeliveryStateData.deliveryTime2}
                      onChange={({ target }) =>
                        allOnChangeHandler("deliveryTime2", target.value)
                      }
                      style={{
                        textAlign: "center",
                        marginLeft: 3,
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        borderBottom: "1px solid #5e89e7",
                        height: 42,
                      }}
                    >
                      {[...Array(60)].map((d, index) => {
                        const formattedValue = index.toString().padStart(2, '0');
                        if (index === 0) {
                          return <option key={index}>{"00"}</option>;
                        }
                        // return <option key={index}>{index}</option>;
                        return <option key={index} value={index}>{formattedValue}</option>;

                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="d-flex flex-column">
                  <span className="section-name-form-style">ON SITE TIME</span>
                  <div className="add-mr-top-for-final-delivery">
                    <select
                      value={finalDeliveryStateData.onsiteTime1}
                      onChange={({ target }) =>
                        allOnChangeHandler("onsiteTime1", target.value)
                      }
                      style={{
                        textAlign: "center",
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        borderBottom: "1px solid #5e89e7",
                        height: 42,
                      }}
                    >
                      {[...Array(24)].map((d, index) => {
                        const formattedValue = index.toString().padStart(2, '0');
                        return (
                          <option key={index} value={index}>
                            {/* {index} */}
                            {formattedValue}
                          </option>
                        );
                      })}
                    </select>
                    :
                    <select
                      value={finalDeliveryStateData.onsiteTime2}
                      onChange={({ target }) =>
                        allOnChangeHandler("onsiteTime2", target.value)
                      }
                      style={{
                        textAlign: "center",
                        marginLeft: 3,
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        borderBottom: "1px solid #5e89e7",
                        height: 42,
                      }}
                    >
                      {[...Array(60)].map((d, index) => {
                        const formattedValue = index.toString().padStart(2, '0');
                        if (index === 0) {
                          return <option key={index}>{"00"}</option>;
                        }
                        // return <option key={index}>{index}</option>;
                        return <option key={index} value={index}>{formattedValue}</option>;

                      })}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="loader-overlay" style={{ display: addNewVehicleLoadingState ? 'flex' : 'none' }}>
              <CircularProgress />
            </div>

            <div className="add-receiver-section-margin-for-final">
              <span className="section-name-form-style ">RECEIVER</span>
            </div>
            <div className="row">
              <div className="col-md-4">
                <TextField
                  className="depot-form-textfields-style"
                  {...register("receiverName")}
                  id="standard-basic"
                  label="NAME"
                  variant="standard"
                />
                <div className="error-field-class">
                  {errors.receiverName?.message && errors.receiverName?.message}
                </div>
              </div>

              <div className="col-md-4">
                <TextField
                  className="depot-form-textfields-style"
                  {...register("receiverPosition")}
                  id="standard-basic"
                  label="POSITION"
                  variant="standard"
                />
                <div className="error-field-class">
                  {errors.receiverPosition?.message &&
                    errors.receiverPosition?.message}
                </div>
              </div>
              <div className=" col-md-4">
                <TextField
                  className="depot-form-textfields-style"
                  {...register("receiverPhone")}
                  id="standard-basic"
                  label="PHONE"
                  type="string"
                  variant="standard"
                />
                <div className="error-field-class">
                  {errors.receiverPhone?.message &&
                    errors.receiverPhone?.message}
                </div>
              </div>
            </div>

            <div>
              <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
                <div className="col-md-2">
                  <InputLabel className="goodsin-form-section-header-name">
                    {" "}
                    {document.length} DOUCMENTS
                  </InputLabel>
                </div>
                <div className="col-md-10">
                  {documentLoader &&
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>}
                </div>
              </div>
              {document.map((d, index) => {
                return (
                  <div key={index} className="row mt-2">
                    <div className="col-md-4">{d?.fileName || ""}</div>
                    <div className="col-md-4"></div>
                    <div
                      className="col-md-4"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        const result = document.filter(
                          (data) => data.uniqueFileId !== d.uniqueFileId
                        );
                        _document([...result]);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyItems: "center",
                          color: "red",
                        }}
                      >
                        <RemoveCircleOutlineOutlinedIcon fontSize="20" />
                        <InputLabel
                          style={{ fontSize: 10, marginTop: -3, color: "red" }}
                        >
                          {" "}
                          Remove
                        </InputLabel>
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className="mt-3">
                <div className="fileUpload-doc">
                  <input
                    type="file"
                    className="upload"
                    multiple
                    onChange={(e) => documentUpload(e)}
                  />
                  <div>
                    <AddCircleOutlinedIcon style={{ fontSize: 16 }} />
                    <span className="add-doc-button-style">ADD DOCUMENT</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="d-flex flex-row justify-content-between"
              style={{ marginTop: 80, marginBottom: 20 }}
            >
              <Button variant="outlined" className="btn-bootstrap-submit-style" style={{ color: "red", borderColor: "red" }} startIcon={<CancelIcon />} onClick={handleFinalDeliveredModalClose}>
                Cancel
              </Button>
              <Button disabled={addNewVehicleLoadingState == true ? true : false} variant="outlined" className="btn-bootstrap-submit-style" startIcon={<CheckCircleIcon />} type="submit"
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FinalDeliveryForm;
